import { formatCollection, formatCollectionPreview, formatGroupedMessage } from './format';
import { parseDate } from './parse-date';

export function parseCollectionDate(date: number): string {
  return parseDate(date, formatCollection);
}

export function parseCollectionPreviewDate(date: number): string {
  return parseDate(date, formatCollectionPreview);
}

export function parseGroupedMessageDate(date: string): string {
  return parseDate(date, formatGroupedMessage);
}
